<div *ngIf="isFirstMenuVisible" id="sidebar" [ngClass]="{ 'sidebar': !isCollapsed, 'sidebar-collapsed': isCollapsed }" class="flex flex-col">
    <div id="logo" class="p-4">
        <img
            [src]="isCollapsed ? '../../../../assets/img/solfium/new-logo-solfium-without_text.svg' : '../../../../assets/img/solfium/new-logo-solfium.svg'"
            class="h-8" alt="Logo"
        />
    </div>

    <div id="options" class="flex flex-col py-4 px-3 grow" [ngClass]="{ 'items-center': isCollapsed }">
        <div class="flex items-center mb-3 p-2 gap-8"
            [ngClass]="{ 'selected': isActive('/dashboard-project-detail-inst') }"
            (click)="navigate('/dashboard-project-detail-inst')"
            matTooltip="Detalle de proyectos"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">featured_play_list</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Detalle de proyectos
            </span>
        </div>
        <div class="flex items-center p-2 gap-8"
            [ngClass]="{ 'selected': isActive('/dashboard-asset-map-inst') }"
            (click)="navigate('/dashboard-asset-map-inst')"
            matTooltip="Mapa de activos"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">location_on</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Mapa de activos
            </span>
        </div>
    </div>

    <div id="actions" class="flex flex-col py-4 px-3" [ngClass]="{ 'items-center': isCollapsed }">
        <div class="flex items-center mb-3 p-2 gap-8"
            [ngClass]="{ 'selected': isActive('/dashboard-profile-inst') }"
            (click)="navigate('/dashboard-profile-inst')"
            matTooltip="Perfil"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">account_circle</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Perfil
            </span>
        </div>
        <div class="flex items-center mb-3 p-2 gap-8" (click)="logout()"
            matTooltip="Cerrar sesión"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed">
            <mat-icon class="material-symbols-rounded">logout</mat-icon>
            <span class="text-14px font-medium" [ngClass]="{ 'hidden': isCollapsed }">
                Cerrar sesión
            </span>
        </div>
    </div>

    <div id="btn" class="flex justify-end py-2 px-3" [ngClass]="{ 'justify-center': isCollapsed }">
        <button class="btnCollapsed" (click)="toggleSidebar()">
            <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
    </div>
</div>

<div *ngIf="isSecondMenuVisible">
    <mat-drawer-container class="hidden-sidebar" autosize>
        <mat-drawer #drawer class="sidenav" mode="side">
            <div class="flex flex-col sidebar h-full">
                <div id="logo" class="p-4">
                    <img
                        [src]="isCollapsed ? '../../../../assets/img/solfium/new-logo-solfium-without_text.svg' : '../../../../assets/img/solfium/new-logo-solfium.svg'"
                        class="h-8" alt="Logo"
                    />
                </div>

                <div id="options" class="flex flex-col py-4 px-3 grow" [ngClass]="{ 'items-center': isCollapsed }">
                    <div class="flex items-center mb-3 p-2 gap-8"
                        [ngClass]="{ 'selected': isActive('/dashboard-project-detail-inst') }"
                        (click)="navigate('/dashboard-project-detail-inst')">
                        <mat-icon class="material-symbols-rounded">featured_play_list</mat-icon>
                        <span class="text-14px font-medium">
                            Detalle de proyectos
                        </span>
                    </div>
                    <div class="flex items-center p-2 gap-8"
                        [ngClass]="{ 'selected': isActive('/dashboard-asset-map-inst') }"
                        (click)="navigate('/dashboard-asset-map-inst')">
                        <mat-icon class="material-symbols-rounded">location_on</mat-icon>
                        <span class="text-14px font-medium">
                            Mapa de activos
                        </span>
                    </div>
                </div>

                <div id="actions" class="flex flex-col py-4 px-3" [ngClass]="{ 'items-center': isCollapsed }">
                    <div class="flex items-center mb-3 p-2 gap-8"
                        [ngClass]="{ 'selected': isActive('/dashboard-profile-inst') }"
                        (click)="navigate('/dashboard-profile-inst')">
                        <mat-icon class="material-symbols-rounded">account_circle</mat-icon>
                        <span class="text-14px font-medium">
                            Perfil
                        </span>
                    </div>
                    <div class="flex items-center mb-3 p-2 gap-8" (click)="logout()">
                        <mat-icon class="material-symbols-rounded">logout</mat-icon>
                        <span class="text-14px font-medium">
                            Cerrar sesión
                        </span>
                    </div>
                </div>
            </div>
        </mat-drawer>

        <div class="sidenav-content">
            <button type="button" mat-icon-button (click)="drawer.toggle()">
                <mat-icon>menu</mat-icon>
            </button>
        </div>
    </mat-drawer-container>
</div>
